/**
 * ヘッダー関連 Class
 */
export default class Header {
	constructor() {
		this.scrollEvent();
		this.scrollFixed();
		this.spNavigation();
		this.accordionChild();
	};

	/**
	 * スクロールイベント
	 */
	scrollEvent() {
		window.addEventListener('scroll', this.scrollFixed);
	};

	/**
	 * 上部固定判定
	 */
	scrollFixed() {
		let $scrollVal = $(window).scrollTop();
		if (0 < $scrollVal) {
			$('.l-header').addClass('is-fixed');
		} else {
			$('.l-header').removeClass('is-fixed');
		}
	};

	/**
	 * スマホナビゲーション開閉
	 */
	spNavigation() {
		let navOpen = function () {
			$('.l-header').addClass('is-open');
		}
		let navClose = function() {
			$('.l-header').removeClass('is-open');
		}
		$(document).on('click', '#js-nav-open', navOpen);
		$(document).on('click', '#js-nav-close', navClose);
		$(document).on('click', '#js-nav-bg', navClose);
	};

	/**
	 * 子要素アコーディオン
	 */
	accordionChild() {
		$(document).on('click', '.js-nav-child', function(){
			let $parent = $(this).parent();
			let $children = $(this).next();
			if ( $parent.hasClass('is-open') ) {
				$parent.removeClass('is-open');
				$children.slideUp();
			} else {
				$parent.addClass('is-open');
				$children.slideDown();
			}
		});
	};
}
